module.exports = __webpack_public_path__ + "static/media/plan-C1b-mobile-tc.30efb143.png";